import "./ghl-ui.es345.js";
import "./ghl-ui.es346.js";
import "./ghl-ui.es347.js";
import "./ghl-ui.es348.js";
import "./ghl-ui.es349.js";
import "./ghl-ui.es350.js";
import "./ghl-ui.es351.js";
import "./ghl-ui.es352.js";
import "./ghl-ui.es353.js";
import "./ghl-ui.es354.js";
import "./ghl-ui.es355.js";
import "./ghl-ui.es356.js";
import "./ghl-ui.es357.js";
import "./ghl-ui.es358.js";
import e from "./ghl-ui.es359.js";
import "./ghl-ui.es360.js";
function v(o) {
  const r = document.querySelectorAll(".n-data-table-tbody");
  if (r.length === 0)
    return null;
  const t = {
    draggable: ".n-data-table-tr",
    mirror: {
      appendTo: r,
      constrainDimensions: !0
    },
    delay: 300,
    classes: {
      mirror: "draggable-mirror",
      "body:dragging": "",
      "container:dragging": "",
      "source:dragging": "",
      "source:placed": "",
      "container:placed": "",
      "draggable:over": "",
      "container:over": "",
      "source:original": ""
    }
  };
  return o && (t.handle = `.${o}`), new e(r, t);
}
export {
  v as default
};
